import { Injectable } from '@angular/core';

import { AnalyticsBase } from '@core/analytics-legacy';

@Injectable()
export class PlaceholdersAnalyticsService extends AnalyticsBase {
  public namespace: string = 'Placeholders';
  public requireViewContext: boolean = true;

  public insertPlaceholder(props: { placeholderName: string }): void {
    this.track('InsertPlaceholder', props);
  }
}
